// extracted by mini-css-extract-plugin
var _1 = "fieldset__q1GVt";
var _2 = "highlighted__MG4RJ";
var _3 = "tabsContainer__MKRj9";
export { _1 as "fieldset", _2 as "highlighted", _3 as "tabsContainer" }
